import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const ListContainer = styled.ul`
  list-style: circle !important;
`;

export const ListItem = styled.li`
  font-size: ${ThemePrisma.fonts.body.s.midContrast.fontSize};
  font-family: ${ThemePrisma.fonts.body.s.midContrast.fontFamily};
  font-weight: ${ThemePrisma.fonts.body.s.midContrast.fontWeight};
  letter-spacing: ${ThemePrisma.fonts.body.s.midContrast.letterSpacing};
  line-height: ${ThemePrisma.fonts.body.s.midContrast.lineHeight};
  color: ${ThemePrisma.colors.gray[7]};
  margin-left: 24px;

  &::marker {
    color: ${ThemePrisma.colors.gray[6]};
    font-size: 1.2em;
  }
`;
